<script>
import RadioChoice from '@/components/RadioChoice.vue';

export default {
  name: 'SingleListFilter',
  components: { RadioChoice },
  props: ['caption', 'options', 'value'],
  data() {
    return {
      selected: {
        color: 'White',
        items: [],
      },
      typeOptions: [
        {
          title: 'Whitelist',
          name: 'White',
        },
        {
          title: 'Blacklist',
          name: 'Black',
        },
      ],
    };
  },
  watch: {
    value: {
      handler(val) {
        this.selected = val;
      },
    },
    selected: {
      deep: true,
      handler(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<template>
  <div>
    <div class="create-feed-form--textarea-heading mb-10">{{ caption }}</div>
    <div>
      <v-select class="select" multiple v-model="selected.items" :options="options" :reduce="item => item.value" :clearable="true">
        <template #option="{ value, label }">
          <span>{{ label }}</span>
        </template>
      </v-select>
      <RadioChoice class="mb-25" title="" :group="caption" :items="typeOptions" v-model="selected.color" @change="(v) => this.selected.color = v" />
    </div>
  </div>
</template>

<style>
.select {
  margin-bottom: 0 !important;
}
</style>
